/*
 *
 * WidgetResume reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_EVOLUTION_MEASURE_WATCHER,
  GET_EVOLUTION_MEASURE_SUCCESS,
  GET_EVOLUTION_MEASURE_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoadingEvolutionMeasure: false,
  evolutionData: [],
  evolutionLines: [],
})

function widgetResumeReducer(state = initialState, action) {
  switch (action.type) {
    case GET_EVOLUTION_MEASURE_WATCHER:
      return state
        .set("isLoadingEvolutionMeasure", true)
        .set("evolutionData", [])
        .set("evolutionLines", [])

    case GET_EVOLUTION_MEASURE_SUCCESS:
      return state
        .set("isLoadingEvolutionMeasure", false)
        .set("evolutionData", action.payload.dataValues)
        .set("evolutionLines", action.payload.dataLines)

    case GET_EVOLUTION_MEASURE_FAILED:
      return state
        .set("isLoadingEvolutionMeasure", false)
        .set("evolutionData", [])
        .set("evolutionLines", [])

    default:
      return state
  }
}

export default widgetResumeReducer
